function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.88,22.12A5.62,5.62,0,0,1,16,21.2a3.25,3.25,0,0,1-1,.12h-.69a3.3,3.3,0,0,1-2.17-.71,5.39,5.39,0,0,0-.95-.83,1.76,1.76,0,0,0-2.1.34,16.82,16.82,0,0,0-2.18,3.4l-.32.76a1.34,1.34,0,0,0-.08,1.18,1.8,1.8,0,0,0,1.33.47h9.47A5.85,5.85,0,0,1,15.88,22.12Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,17.86A4.67,4.67,0,0,0,18.88,13v-.11a4.47,4.47,0,0,0-4.32-4.62h-.18a4.47,4.47,0,0,0-4.23,4.68C10.16,15.65,12.1,17.86,14.5,17.86Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25,11a.82.82,0,0,1,.84.81.13.13,0,0,1,0,.06v1.93a.82.82,0,0,1-.76.88H20.27a.86.86,0,0,1-.83-.88V11.9a1.06,1.06,0,0,1,.55-.83.09.09,0,0,0,.08-.08h0A5.74,5.74,0,0,0,14.6,6.82,5.94,5.94,0,0,0,9.11,11c0,.19.09.09.27.19a.75.75,0,0,1,.46.76V13.8a.93.93,0,0,1-.64.88c-.09.1,0,.19,0,.28a5.7,5.7,0,0,0,3.72,3.68c.46.09.18-.48,1-.48h1.61a.64.64,0,0,1,.64.64v0h0v.79a.63.63,0,0,1-.61.66H14c-.36,0-.64-.09-.72-.47a.5.5,0,0,0-.47-.28,7.07,7.07,0,0,1-4.37-4.37C8.3,15,8.3,14.77,8,14.77l-.09-.1a.88.88,0,0,1-.88-.83V11.91a.92.92,0,0,1,.88-.83c.08,0,.27,0,.27-.18A6.72,6.72,0,0,1,14.53,6a6.51,6.51,0,0,1,6.37,4.86A.54.54,0,0,0,21.25,11Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.43,17.62a4.19,4.19,0,1,0,4.19,4.19A4.2,4.2,0,0,0,21.43,17.62Zm.24,6.64h-.78v-.78h.78Zm1.18-2.5a1.48,1.48,0,0,1-.69.36c-.54.18-.54.23-.54.7h-.79v-.06c0-.83.06-.87,1.13-1.31a.59.59,0,0,0,.47-.69c0-.65-.11-.78-.95-.78-.59,0-.83.06-.94.29s-.07.19-.07.66h-.69v-.17c0-.54.06-.78.24-1a2.22,2.22,0,0,1,1.52-.36,1.83,1.83,0,0,1,1.31.29c.24.18.31.48.31,1s-.06.83-.3,1Z",
    style: {
      fill: "#e44817"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceUnknown);
export default __webpack_public_path__ + "static/media/presence-unknown.034a5a41.svg";
export { ForwardRef as ReactComponent };